const optionValidatorMixin = {
	methods: {
		alertWithInvalidOptions(requisites) {
			const namesArray = requisites.map((option) => {
				return option.name;
			});
			const first = namesArray[0][0];
			const vowel = ([first].includes('a', 'e', 'i', 'o', 'u')) ? 'an' : 'a';
			const plural = (namesArray.length > 1) ? 'the following: ' : `${vowel} `;
			const names = namesArray.join(',');
			this.$modal.show('dialog', {
				title: 'Selection Needed',
				text: `Please choose ${plural}${names}`,
				buttons: [
					{
						title: 'OK',
					},
				],
			});
		},
		alertBundleIncomplete() {
			this.$modal.show('dialog', {
				title: 'Selection Needed',
				text: 'Please choose remaining bundle items.',
				buttons: [
					{
						title: 'OK',
					},
				],
			});
		},
		alertErrorWithMessage(message) {
			const title = 'Oops! there was a error';
			this.alertWithMessage(title, message);
		},
		alertWithMessage(title, message) {
			this.$modal.show('dialog', {
				title: `${title}`,
				text: `${message}`,
				buttons: [
					{
						title: 'OK',
					},
				],
			});
			this.adjustModalPlacement();
		},
		adjustModalPlacement() {
			setTimeout(() => {
				const modal = document.querySelector('.v--modal-overlay');
				modal.style.top = `0px`;
			}, 0);
		},
	},
};

export default optionValidatorMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/optionValidatorMixin.js